// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n/* .el-table__fixed,\n.el-table__fixed-right {\n  height: calc(100% - 11px) !important;\n  -moz-height: calc(100% - 17px) !important;\n  -ms-height: calc(100% - 17px) !important;\n  -o-height: calc(100% - 17px) !important;\n}\n\n.el-table__fixed:before {\n  content: '';\n  height: 0 !important;\n} */\n", ""]);
// Exports
module.exports = exports;
